import { ParcelaNegociadaDividaDto } from '../dto/DetalheOfertaDto';

class ParcelaNegociadaDividaResource {
  numeroParcela: string;
  dataVencimento: Date;
  valor: number;

  constructor(dto: ParcelaNegociadaDividaDto) {
    this.numeroParcela = dto.numeroParcela;
    this.dataVencimento = new Date(dto.dataVencimento);
    this.valor = dto.valor;
  }
}

export default ParcelaNegociadaDividaResource;
